/*jslint regexp: true */

/**
 * A reusable dropdown plugin for jQuery
 * Allows the user to choose from a list of options or type a custom option
 */
(function ($) {
   "use strict";

   var m_aIds = [],

      /**
       * Generate a unique id for a new element
       */
      generateId = function () {
         var strRandomId = "generated_" + (Math.floor(Math.random() * 1000)).toString();
         m_aIds.push(strRandomId);
         return strRandomId;
      },

      /**
       * Destroy copies that no longer exist.
       * Old copies are bad because they:
       *  - Mess up tab indexes
       *  - Slow down the page with excess events calls / elements
       *  - Make it hard to debug
       */
      deleteOld = function () {
         setTimeout(function () {
            $.each(m_aIds, function (i, strId) {
               var strBaseId = "#" + strId,
                  strInputId = "." + strId + "_input";

               // If this input is in limbo
               if ($(strInputId).length === 0) {
                  // Trigger extermination protocol
                  $(strBaseId).remove();
               }
            });
         }, 800);
      },

      methods = {
         /**
          * Create the dropdown
          * Required options:
          * Optional options: 
          *   dropdownClass - An additional class for the dropdown
          */
         init: function (list, config) {
            // TODO: When dropdown is at the bottom of the page, reposition the dropdown so that it appears within view
            return this.each(function () {
               var jBaseInput = $(this),
                  data = jBaseInput.data('c21dropdown'),
                  options = $.extend({
                     dropdownClass: null,
                     appearUnderText: true,
                     onBlur: null,
                     hoverElement: null,
                     relativeTo: null,
                     onTrigger: null,
                     listOptions: {}
                  }, config);

               // If the plugin hasn't been initialized yet
               if (!data) {
                  deleteOld();
                  data = {};

                  var m_bClickEventInsideDropdown = false,
                     m_bHideTriggeredByThisDropdown = false,

                     strRandomId = generateId(),
                     jDropdown = $('<div />', {
                        id: strRandomId,
                        html: [
                           '<div class="dropdownHeader">',
                           '</div>',
                           '<div class="optionList"></div>'
                        ].join(''),
                        "class": 'dropdownBox'
                     }),
                     jDropdownHeader = jDropdown.find('.dropdownHeader'),
                     jOptionList = jDropdown.find('.optionList'),

                     addHeaderHighlight = function () {
                        jOptionList.c21list("removeHighlight");
                        jDropdownHeader.addClass("dropdownOption dropdownOptionSelected");
                     },

                     removeHeaderHighlight = function () {
                        if (!jDropdownHeader.hasClass("dropdownOptionSelected")) {
                           return;
                        }

                        jDropdownHeader.removeClass("dropdownOption dropdownOptionSelected");
                        jOptionList.c21list("moveDown");
                     },

                     teardownDropdownEvents,

                     hideDropdown = function () {
                        var bWasVisible = data.showing;
                        data.showing = false;
                        jDropdown.offset({
                           top: -9999,
                           left: -9999
                        }).show();

                        // NOTE: Fires after onBlurAndChange
                        if (options.onBlur && bWasVisible) {
                           options.onBlur();
                        }

                        teardownDropdownEvents();
                     },

                     /**
                      * When a key is pressed in the window
                      */
                     onWindowKeyDown = function (event) {
                        var iKeyCode = event.keyCode;

                        switch (iKeyCode) {
                        // ENTER key or SPACE bar
                        case 13:
                        case 32:
                           if (options.onTrigger) {
                              options.onTrigger();
                           }
                           return false;

                        // UP arrow
                        case 38:
                           jOptionList.c21list("moveUp");
                           return false;

                        // RIGHT arrow or TAB key
                        case 39:
                        case 9:
                           return;

                        // DOWN arrow
                        case 40:
                           jOptionList.c21list("moveDown");
                           return false;
                        }
                     },

                     handleHtmlClick = function () {
                        setTimeout(function () {
                           if (!m_bClickEventInsideDropdown) {
                              hideDropdown();
                           }

                           m_bClickEventInsideDropdown = false;
                        }, 10);
                     },

                     handleWindowResize,

                     setupDropdownEvents = function () {
                        // These events are attached to pre-existing elements.
                        // They must be torn down when the plugin instance is destroyed.
                        $("html").on("mousedown.c21dropdown", handleHtmlClick);
                        $(window).on("resize.c21dropdown", handleWindowResize);
                        $(document).on("hideDropdowns.c21dropdown", hideDropdown);
                        $(document.body).on("keydown.c21dropdown", onWindowKeyDown);
                     },

                     /**
                      * It is important that the dropdown always stays
                      * display: block, or the user will never be able to tab
                      * to inputs in the dropdown. We "show" the dropdown
                      * by repositioning it into view.
                      */
                     showAndRepositionDropdown = function () {
                        var offsetInput = options.relativeTo.offset(),
                           iPadding,
                           iInputWidth,
                           offsetDropdown;

                        // If the input is not showing
                        if (offsetInput.left === 0) {
                           // Don't do anything...
                           return;
                        }

                        if (options.appearUnderText) {
                           offsetDropdown = {
                              top: offsetInput.top + options.relativeTo.height(),
                              left: offsetInput.left
                           };
                        } else {
                           iPadding = 7;
                           iInputWidth = options.relativeTo.width();
                           offsetDropdown = {
                              top: offsetInput.top - iPadding + 1,
                              left: offsetInput.left - iPadding,
                              right: iInputWidth + iPadding
                           };
                        }

                        // Required for Chrome to properly show the
                        // dropdown the first time...
                        jDropdown.css({
                           top: offsetDropdown.top,
                           left: offsetDropdown.left,
                           display: 'block'
                        });

                        // Normally .css would work, but this is
                        // required for IE7-8 to display the dropdown
                        // in the correct position
                        jDropdown.offset(offsetDropdown);

                        var iHeaderWidth = jDropdownHeader.outerWidth(),
                           jDropdownChild = jOptionList.children(0),
                           iDropdownWidth = jDropdownChild.outerWidth();

                        if (iDropdownWidth > iHeaderWidth) {
                           jDropdownHeader.css("width", iDropdownWidth);
                        } else {
                           jDropdownChild.css("width", iHeaderWidth);
                        }

                        data.showing = true;
                        setupDropdownEvents();
                     },

                     toggleDropdown = function () {
                        if (data.showing) {
                           hideDropdown();
                        } else {
                           showAndRepositionDropdown();
                        }
                     },

                     setupHover = function () {
                        if (!options.hoverElement) {
                           return;
                        }

                        jDropdown.on({
                           mouseenter: function () {
                              options.hoverElement.addClass("hover");
                           },
                           mouseleave: function () {
                              options.hoverElement.removeClass("hover");
                           },
                           mousedown: function (e) {
                              options.hoverElement.addClass("active");
                           },
                           mouseup: function () {
                              options.hoverElement.removeClass("active");
                           }
                        });
                     },

                     initialize = function () {
                        if (options.dropdownClass) {
                           jDropdown.addClass(options.dropdownClass);
                        }

                        jDropdown.on({
                           click: function (e) {
                              e.stopPropagation();
                              m_bClickEventInsideDropdown = false;
                           },
                           mousedown: function (e) {
                              // Mousedown fires after click, but before "blur" event would
                              // be fired for the input, if selected
                              // The goal being: Don't hide the dialog if the user
                              // simply clicked inside of it (as opposed to tabbing out of it)
                              m_bClickEventInsideDropdown = true;
                              e.stopPropagation();
                           }
                        });

                        setupHover();

                        jDropdownHeader.on("click", function () {
                           if (jDropdownHeader.hasClass("dropdownOption")) {
                              addHeaderHighlight();
                           }
                        });

                        jOptionList.c21list($.extend({
                           options: list,
                           translate: options.translate,
                           baseInput: jBaseInput,
                           standAlone: false
                        }, options.listOptions));

                        if (options.headerContent) {
                           jDropdownHeader.append(options.headerContent);
                        } else {
                           jDropdownHeader.hide();
                        }

                        $(document.body).append(jDropdown);

                        $.extend(data, {
                           target: jBaseInput,
                           jDropdown: jDropdown,
                           jDropdownHeader: jDropdownHeader,
                           jOptionList: jOptionList,
                           teardownDropdownEvents: teardownDropdownEvents,
                           toggleDropdown: toggleDropdown,
                           showAndRepositionDropdown: showAndRepositionDropdown,
                           addHeaderHighlight: addHeaderHighlight,
                           removeHeaderHighlight: removeHeaderHighlight,
                           hideDropdown: hideDropdown,
                           strRandomId: strRandomId,
                           showing: false
                        });

                        jBaseInput.data("c21dropdown", data);

                        hideDropdown();
                     };

                  teardownDropdownEvents = function () {
                     $("html").off("mousedown.c21dropdown", handleHtmlClick);
                     $(window).off("resize.c21dropdown", handleWindowResize);
                     $(document).off("hideDropdowns.c21dropdown", hideDropdown);
                     $(document.body).off("keydown.c21dropdown", onWindowKeyDown);
                  };

                  handleWindowResize = function () {
                     showAndRepositionDropdown();
                  };

                  initialize();
               }
            });
         },

         getRandomId: function () {
            var data = $(this).data("c21dropdown");
            return data.strRandomId;
         },

         removeHeaderHighlight: function () {
            var data = $(this).data("c21dropdown");
            return data.removeHeaderHighlight();
         },

         addHeaderHighlight: function () {
            var data = $(this).data("c21dropdown");
            return data.addHeaderHighlight();
         },

         showAndRepositionDropdown: function () {
            var data = $(this).data("c21dropdown");
            return data.showAndRepositionDropdown();
         },

         hideDropdown: function () {
            var data = $(this).data("c21dropdown");
            return data.hideDropdown();
         },

         toggle: function () {
            var data = $(this).data("c21dropdown");
            return data.toggleDropdown();
         },

         getOptionList: function () {
            var data = $(this).data("c21dropdown");
            return data.jOptionList;
         },

         getHeader: function () {
            var data = $(this).data("c21dropdown");
            return data.jDropdownHeader;
         },

         getSelectedValue: function () {
            var data = $(this).data("c21dropdown");
            return data.jOptionList.c21list("getValue");
         },

         getSelectedText: function () {
            var data = $(this).data("c21dropdown");
            return data.jOptionList.c21list("getText");
         },

         /**
          * Determine whether this element is hidden
          */
         hidden: function () {
            var data = $(this).data("c21dropdown");
            return (data === undefined) ? false : !data.showing;
         },

         destroy: function () {
            return this.each(function () {
               var jBaseInput = $(this),
                  data = jBaseInput.data('c21dropdown');

               data.teardownDropdownEvents();
               data.c21dropdown.remove();
               jBaseInput.removeData("c21dropdown");
            });
         }
      };

   $.fn.c21dropdown = function (method) {
      if (methods[method]) {
         return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
      } else if (typeof method === 'object' || !method) {
         return methods.init.apply(this, arguments);
      } else {
         $.error('Method ' + method + ' does not exist on jQuery.c21dropdown');
      }
   };
}(jQuery));

